import { render, staticRenderFns } from "./logout.vue?vue&type=template&id=157b3650&scoped=true"
var script = {}
import style0 from "./logout.vue?vue&type=style&index=0&id=157b3650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157b3650",
  null
  
)

export default component.exports